import React from 'react';

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[1000],
  lineHeight: '1.1'
}));

const StyledName = styled(Typography)(() => ({
  fontSize: '1rem',
  fontWeight: 'bold',
  width: '10rem',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

const SessionSpeakers = ({ speakers = {} }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mr: 3,
        mb: { xs: 1, md: 0.9 },
        minWidth: '14rem'
      }}
    >
      <Avatar sx={{ width: '3rem', height: '3rem', mr: 1.5 }} />
      <Box sx={{ textAlign: 'left' }}>
        <Box>
          <StyledName>{`${speakers.eventParticipant?.name}`}</StyledName>
          {speakers.eventParticipant?.company && (
            <Typography color='gray'>{speakers.eventParticipant.company.name}</Typography>
          )}
        </Box>
        {speakers.role && <StyledTypography>{speakers.role.value}</StyledTypography>}
      </Box>
    </Box>
  );
};

export default SessionSpeakers;
